import React, { useState } from "react";
import { Settings, Search, ChevronLeft } from "lucide-react";
import { Button } from "@/components/ui/Button";
import { Input } from "@/components/ui/Input";
import { Label } from "@/components/ui/Label";
import { Combobox } from "@/components/ui/Combobox";
import { useNavigate } from "react-router-dom";

const SettingsPage = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [formData, setFormData] = useState({
    site_name: "",
    admin_email: "",
    timezone: "",
    backup_frequency: "",
  });

  // Mock data for dropdowns
  const timezones = [
    { name: "UTC" },
    { name: "America/New_York" },
    { name: "America/Los_Angeles" },
    { name: "Europe/London" },
    { name: "Asia/Tokyo" },
  ];

  const backupOptions = [
    { name: "Daily" },
    { name: "Weekly" },
    { name: "Monthly" },
    { name: "Never" },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSelectChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <div className="slide-up">
      <div className="w-full">
        <div className="slide-up">
          <form onSubmit={handleSubmit} className="">
            {/* Site Name and Admin Email */}
            <div className="grid grid-cols-1 gap-4 mb-4 md:grid-cols-2 lg:grid-cols-3">
              <div className="space-y-3">
                <Label
                  htmlFor="site_name"
                  className="pl-3 text-xs font-medium uppercase text-gray-0"
                >
                  Site Name:
                </Label>
                <Input
                  id="site_name"
                  name="site_name"
                  type="text"
                  placeholder="Minesure Application"
                  value={formData.site_name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="space-y-3">
                <Label
                  htmlFor="admin_email"
                  className="pl-3 text-xs font-medium uppercase text-gray-0"
                >
                  Admin Email:
                </Label>
                <Input
                  id="admin_email"
                  name="admin_email"
                  type="email"
                  placeholder="admin@minesure.com"
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="space-y-3">
                <Label
                  htmlFor="timezone"
                  className="pl-3 text-xs font-medium uppercase text-gray-0"
                >
                  Timezone:
                </Label>
                <Combobox
                  onValueChange={(value) => handleSelectChange("timezone", value)}
                  placeholder="Select Timezone"
                  searchPlaceholder="Search timezones..."
                />
              </div>
            </div>

            {/* Submit Buttons */}
            <div className="flex flex-col items-stretch border-t border-b border-gray-0 md:flex-row md:justify-end">
              <div className="flex items-center justify-center w-full md:w-auto">
                <Button
                  type="button"
                  onClick={() => navigate(-1)}
                  variant="secondary"
                  className="flex items-center justify-center w-full h-auto px-10 py-5 text-xs font-normal uppercase rounded-none rounded-b-none border-gray-0 text-gray-0 md:w-auto md:border-r"
                >
                  <ChevronLeft className="w-4 h-4 mr-2 text-red-500" />
                  BACK
                </Button>
                <Button
                  className="flex items-center justify-center w-full h-auto px-10 py-5 text-xs font-normal text-red-500 uppercase bg-transparent border-0 rounded-none rounded-b-none md:w-auto"
                  type="submit"
                >
                  Save Settings
                </Button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SettingsPage;
